<template>
  <component
    :is="layout"
  >
    <router-view />
  </component>

  <!--
    หน้าล็อกอายุการใช้งาน — คลุมทับหน้าจอพนักงานที่ล็อกอินอยู่ (admin / POS / KDS — LOCK_LAYOUTS)
    ไม่ขึ้นที่:
      • authorization-layout (login/register) — ต้องล็อกอินเข้ามาได้เสมอ ไม่งั้นเจ้าของร้าน
        เข้ามาดูไม่ได้เลยว่าเกิดอะไรขึ้น (BE ก็เปิดเส้น login ไว้ให้ตลอดเช่นกัน)
      • service-layout (หน้า QR ลูกค้า) — ลูกค้าของร้านไม่ควรเห็นเรื่องบิลของร้าน
        หน้านั้นมีข้อความกลาง ๆ ของตัวเองอยู่แล้ว
      • ช่วงหน้าเพิ่งโหลดที่ route ยังไม่มี layout (เช่นหลังกดออกจากระบบ) — ดู onStaffScreen()
  -->
  <LicenseLockScreen v-if="showLockScreen" />

  <!-- popup เตือนต่ออายุตอนเปิดแอป (ใกล้หมด / ผ่อนผัน) — ไม่ขึ้นที่จอ KDS ในครัว มีแค่แถบ -->
  <LicenseReminder v-else-if="showReminder" />
</template>

<script>
import AdminLayout from './layouts/AdminLayout.vue'
import AuthorizationLayout from './layouts/AuthorizationLayout.vue'
import POSLayout from './layouts/POSLayout.vue'
import KDSLayout from './layouts/KDSLayout.vue'
import ServiceLayout from './layouts/ServiceLayout.vue'
import LicenseLockScreen from './components/license/LicenseLockScreen.vue'
import LicenseReminder from './components/license/LicenseReminder.vue'
import { useLicenseStore } from '@/stores/license.store'
import { useAuthStore } from '@/stores/auth.store'

// หน้าล็อก / popup เตือน ขึ้นเฉพาะ "หน้าจอพนักงานที่ล็อกอินอยู่" — เขียนเป็นลิสต์ที่อนุญาต ไม่ใช่ลิสต์ที่ห้าม
// เพราะตอนหน้าเพิ่งโหลด (START_LOCATION) route ยังไม่มี layout → ลิสต์ห้ามจะปล่อยผ่าน
// เคสจริง: ร้านหมดอายุกดออกจากระบบ → reload → popup แวบขึ้นก่อน router พาไปหน้า login
// login / register / หน้า QR ลูกค้า ไม่อยู่ในลิสต์ = ไม่ขึ้นเลย (ลูกค้าของร้านห้ามเห็นเรื่องบิลระหว่างเรากับร้าน)
// route ส่วนใหญ่ของ KDS ใช้ 'k-d-s-layout' · มี 1 route ที่ตั้งเป็น 'KDSLayout' ตรง ๆ
const LOCK_LAYOUTS = ['admin-layout', 'p-o-s-layout', 'k-d-s-layout', 'KDSLayout'];
// จอ KDS เปิดค้างทั้งวันในครัว ไม่มีใครจ่ายเงินจากตรงนั้น — แถบพอ ไม่ต้องมี popup บังจอ
const REMINDER_LAYOUTS = ['admin-layout', 'p-o-s-layout'];

export default {
  name: "App",
  components: {
    AdminLayout,
    AuthorizationLayout,
    POSLayout,
    KDSLayout,
    ServiceLayout,
    LicenseLockScreen,
    LicenseReminder
  },
  data() {
    return {
      defaultMetaTitle: 'Manage Store'
    }
  },
  methods: {
    /** ล็อกอินอยู่ + route ตัดสินเสร็จแล้วว่าเป็นหน้าจอพนักงานในลิสต์ */
    onStaffScreen(layouts) {
      return useAuthStore().loggedIn && layouts.includes(this.$route.meta.layout);
    }
  },
  async mounted() {
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    },
    title() {
      return this.$route.meta.title + ' - ' + this.$route.meta.suffix
    },
    showLockScreen() {
      return this.onStaffScreen(LOCK_LAYOUTS) && useLicenseStore().showLockScreen;
    },
    showReminder() {
      return this.onStaffScreen(REMINDER_LAYOUTS) && useLicenseStore().showReminder;
    }
  }
}
</script>

<style lang="scss">
@import "bootstrap/scss/bootstrap";
@import '@/assets/scss/custom.scss';
</style>
